import { Link as RouterLink } from 'react-router';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { paths } from '@/config/paths';

const NotFoundRoute = () => {
  const { t } = useTranslation();

  return (
    <div className='mt-16 flex flex-col items-center font-semibold'>
      <h1 className='mb-2 text-3xl font-bold'>{t('notFound.title')}</h1>
      <p className='mb-4 text-base text-muted-foreground'>{t('notFound.description')}</p>
      <Button asChild>
        <RouterLink to={paths.home.getHref()} replace>
          {t('common.buttons.goHome')}
        </RouterLink>
      </Button>
    </div>
  );
};

export default NotFoundRoute;
